import axios from "axios";

const endpoint_url = "/account/api/v1/users/new";

const get = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          ...parameters
        }
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getNewEmployee = {
  get
};

export default getNewEmployee;
